<template>
    <div class="consul">

      <div class="consul_header">
        <div class="title">患者：{{ current_patient.userName }} {{ current_patient.patientSex }} {{ current_patient.patientAge }}</div>
        <div class="info">
          {{ current_patient.visitTime }} {{ current_patient.visitTypeName }}
          <span v-if="['待支付','待接诊','咨询中'].indexOf(current_patient.visitStatus) !== -1" class="current">
            {{current_patient.visitStatus}}
          </span>
          <span v-else-if="['已退诊','超时未接诊','已退款'].indexOf(current_patient.visitStatus) !== -1" class="danger">
            {{current_patient.visitStatus}}
          </span>
          <span v-else-if="['已取消'].indexOf(current_patient.visitStatus) !== -1" class="cancel">
            {{current_patient.visitStatus}}
          </span>
          <span v-else-if="['已完成'].indexOf(current_patient.visitStatus) !== -1" class="end">
            {{current_patient.visitStatus}}
          </span>
        </div>
      </div>

    <div class="fn-jump">
        <div class="jump-btn" @click="goBack">
            <img src="/static/img/btn_back.svg" alt="" />
        </div>
    </div>

      <div class="consul_body">

        <div class="content_list">
          <div class="live-list-section">
            <div v-if="consul && consul.length > 0" class="content_list_section">
              <div class="content_list_section-container" :key="i" v-for="(item,i) in consul">

                <van-row class="content_list_section-box">
                  <div class="content_list_section-left">
                    <div class="content_list_section-icon">
                        <div v-if="item.userType === 'U'">
                            <div v-if="item.userImg">
                                <img :src="item.userImg" alt="">
                            </div>
                            <div class="emptyAvatar" v-else>
                                {{item.nickname.substring(item.nickname.length - 2)}}
                            </div>
                        </div>
                        <div v-else-if="item.userType === 'D'">
                            <div v-if="item.doctorImg">
                                <img :src="item.doctorImg" alt="">
                            </div>
                            <div class="emptyAvatar" v-else>
                                {{item.doctorName.substring(item.doctorName.length - 2)}}
                            </div>
                        </div>
                        <div v-else>

                        </div>
                    </div>
                    <div class="content_list_section-consul">
                      <div class="content_list_section-name">{{item.userType === 'U' ? item.nickname : item.doctorName}} {{item.userType === 'D' ? item.departmentName : ''}}</div>
                      <div class="content_list_section-info" v-if="item.imContent.tagDescList  && item.imContent.tagDescList.length > 0">
                          <div v-for="v in item.imContent.tagDescList">
                              {{v.value}}
                          </div>
                      </div>
                        <div class="content_list_section-info" v-else-if="item.imContent.conditionDesc !== ''">{{item.imContent.conditionDesc}}</div>
                      <div class="content_list_section-info" v-if="item.imContent.text !== ''">{{item.imContent.text}}</div>
                      <div class="content_list_section-img" v-if="item.imContent.images && item.imContent.images.length > 0">
                        <img @click="previewImage(item.imContent.images,start)" :src="val.s" v-for="(val,i) in item.imContent.images" alt="">
                      </div>
                      <div class="content_list_section-audio" v-if="item.imType === 'audio'">
                        <audio style="margin-top: 20px;margin-bottom: 8px" width="320" :src="item.imContent.url" controls></audio>
                      </div>
                      <div class="content_list_section-img" v-if="item.imType === 'audio_video' || item.imType === 'video_consult_meet'">
                        <video width="300" height="200" style="margin-bottom: 8px;margin-top: 10px" :src="item.imContent.url" controls></video>
                      </div>
                      <div class="content_list_section-date">{{item.imDt}}</div>
                      <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                  </div>
                </van-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import videoListSkeleton from '@/skeleton/videoListSkeleton'
import wx from "weixin-js-sdk";
import {toHomePage} from "../../util/common";
import {ImagePreview} from "vant";
export default {
    name: 'live-list',
    components: {
        'video-list-skeleton': videoListSkeleton
    },
    data() {
        return {

          current_patient:{},

          finished: [],
          live_types: [
            { id: '0', title: '全部' },
            { id: '1', title: '咨询' },
            { id: '2', title: '预约挂号' },
            { id: '3', title: '门诊' },
            { id: '4', title: '住院' },
            { id: '5', title: '互联网诊疗' }
          ],
          consul:[],
          category_index: 0,


          value: '',
          active: '',
          category_id: 0,
          recommend: [],
          list: [],
          column: [],
          backs: [],
          loading: true,
          page: 1,
          pageSize: 10,
          total_page: 1,
          record_id: 0
        }
    },
    activated() {
        this.fetch('banner')
        this.fetch('homepage')
        sessionStorage.removeItem('search_data')
    },
    methods: {
        onSearch() {
            this.fetch('homepage')
        },
        onCancel() {
            this.value = ''
            this.fetch('homepage')
        },
        fetch(scene) {
            if (scene === 'baseinfo') {
                Interface.getData('get', Interface.gb_proxy.baseinfo, {}).then(res => {
                  if(res.code === 0){
                    this.baseinfo = res.data
                  }
                })
            }else if (scene === 'consul') {
              Interface.getData('postJson', Interface.gb_proxy.consul, {
                patientId: this.current_patient.patientId,
                consultId: this.current_patient.consulId
              }).then(res => {
                if(res.code === 0){
                  this.consul = res.data
                }
              })
            }
        },
        fetch_more() {
            this.page += 1
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                live_type: this.category_id
            }
            Interface.getData('get', Interface.live.reBack, params).then(res => {
                this.backs.push(...res.data.list)
                this.total_page = res.data.total_page
            })
        },
        go_detail(item) {
            if (item.live_status === 6) {
                Interface.goLive(this, item.id,item.type, item.live_status)
                Interface.mFootPrint(item.id,4,3,2,0,0,0,item.title)
                sessionStorage.setItem('pageType',2)
            } else {
                if (item.live_status === 0) {
                    Interface.goLive(this, item.id,item.type, item.live_status)
                } else {
                    Interface.goLive(this, item.id,item.type, item.live_status)
                    sessionStorage.setItem('pageType',2)
                }
            }
        },
        goBack() {
            if(this.$router.history) {
                this.$router.go(-1)
            }else{
                this.$router.push({name: 'co_user_detail'})
            }

        },
        previewImage(images, start){
            let imagesArray = []
            for (let i = 0; i < images.length; i++) {
                imagesArray.push(images[i].b)
            }
            ImagePreview({
                images: imagesArray,
                startPosition: start
            })
        }
    },
    created() {
      let current_patient = localStorage.getItem('consul_baseinfo')
      this.current_patient = JSON.parse(current_patient)
      this.fetch('consul')
    }
}
</script>
<style lang="scss">
@import './consul';
</style>



// WEBPACK FOOTER //
// src/views/co_user_detail/consul.vue